// 복습(재시험)을 만들 수 있는 문제지 유형.
// **판정은 서버가 한다.** `api/utils/assignment/wrong_answer.py` 의 같은 이름 상수가
// 정본이고, 여기 있는 것은 버튼을 보여 줄지 정하는 화면용 사본이다. 한쪽을 고치면
// 다른 쪽도 고칠 것.
//
// 예전에는 화면에만 `["vocabulary", "paragraph"]` 가 박혀 있어서, 서버는 되는데
// 내용이해·지문분석 과제에는 복습 버튼이 아예 그려지지 않았다
// (2026-09 김윤경 학원 신고 4건).
export const RETRY_SUPPORTED_TYPE_LIST = [
  "vocabulary",
  "paragraph",
  "grammar",
  "sentence",
  "comprehensive",
  "analysis",
  "bank",
];

/** 빈칸 정답을 견주기 전에 다듬는다.
 *
 * 시험지 정답에는 문장 끝의 마침표·쉼표가 그대로 붙어 있는 일이 많다
 * (최근 문장테스트 빈칸 문항의 36%). 아이가 "can be useful" 이라고 제대로 적어도
 * 정답이 "can be useful." 이라 틀린 것으로 처리됐다.
 *
 * 지문분석 빈칸(EngBlankPage)은 오래전부터 문장부호를 지우고 견주고 있다.
 * 같은 성격의 빈칸이 화면마다 다르게 채점되지 않도록 이 규칙 하나로 모은다.
 *
 * 안쪽 문장부호는 그대로 둔다. world-famous 의 붙임표나 isn't 의 아포스트로피는
 * 뜻을 가르는 자리라 지우면 안 된다.
 */
export const normalizeBlankAnswer = (text) =>
  String(text ?? "")
    .replace(/[‘’ʼ]/g, "'")   // 굽은 작은따옴표를 곧은 것으로
    .replace(/[“”]/g, '"')         // 굽은 큰따옴표
    .replace(/\s+/g, " ")                    // 사이의 여러 칸을 한 칸으로
    .trim()
    .replace(/^[.,!?;:"'()[\]]+|[.,!?;:"'()[\]]+$/g, "")   // 앞뒤 문장부호만
    .trim()
    .toLowerCase();

/** 아이가 적은 것과 정답이 같은가. */
export const isBlankAnswerCorrect = (input, answer) =>
  normalizeBlankAnswer(input) === normalizeBlankAnswer(answer);

/** 구문분석에서 낱말 묶음을 만들 때 쓰는 정리 규칙.
 *
 * 묶는 중간에 이미 다른 묶음이 있으면, 그 묶음 덩어리가 통째로 새 묶음의 낱말
 * 자리에 들어가 화면이 어긋났다. 실제로 "Choosing a career" 안의 관사 자리가 빈
 * 칸이 되고 'a' 가 뒤에 한 번 더 나왔다(2026-08-29 제보).
 *
 * 그래서 묶음은 풀어서 낱말로 만들고, 같은 낱말이 두 번 들어가지 않게 하며,
 * 문장에 놓인 차례(index)대로 세운다.
 */
export const flattenBlockTokens = (block) => {
  if (!block) return [];
  if (block.type === "group") return block.text || [];
  return [block];
};

export const orderedTokenList = (blockList) => {
  const byIndex = new Map();
  (blockList || []).forEach((block) =>
    flattenBlockTokens(block).forEach((token) => {
      if (token && typeof token.index === "number" && !byIndex.has(token.index)) {
        byIndex.set(token.index, token);
      }
    })
  );
  return [...byIndex.values()].sort((a, b) => a.index - b.index);
};
